<template>
    <component
        :is="componentType"
        class="items-center text-white transition-colors text-left duration-300 hover:bg-primary py-1 px-2 text-sm focus:outline-none mx-px h-8 whitespace-nowrap"
        :class="{
            'rounded-l-full ml-0': roundLeft,
            'rounded-r-full mr-0': roundRight,
            'bg-tertiary': !active,
            'bg-primary': active,
            'inline-flex': !block,
            'flex w-full': block,
        }"
        :disabled="disabled"
        :href="!!href ? href : null"
        :target="type === 'a' ? target : null"
        @click="$emit('click', $event)"
    >
        <template v-if="$slots.icon">
            <div class="w-5">
                <slot name="icon" />
            </div>
        </template>
        <div
            v-if="$slots.default"
            class="mx-1 flex-1"
            :class="{
                'hidden md:block': !!$slots.icon,
            }"
        >
            <slot />
        </div>
    </component>
</template>

<script>
import {computed} from "vue";
import {Link} from "@inertiajs/inertia-vue3";

export default {
    emits: ['click'],
    name: "ToolbarButton",
    props: {
        block: Boolean,
        href: String,
        first: Boolean,
        last: Boolean,
        single: Boolean,
        disabled: Boolean,
        type: {
            type: String,
            default: 'link',
            validator (value) {
                return ['link', 'a', 'button'].indexOf(value) !== -1;
            }
        },
        target: String,
        active: Boolean,
    },
    setup (props) {

        const componentType = computed(() => {
            if (props.type === 'link') {
                return Link;
            }

            return props.type;
        })

        const roundLeft = computed(() => {
            return props.first || props.single;
        });

        const roundRight = computed(() => {
            return props.last || props.single;
        });

        return {
            componentType,
            roundLeft,
            roundRight,
        }
    },
}
</script>

<style scoped>

</style>
